import { supabase } from '../lib/supabase';

export const jobAppStatuses = [
  'Applied',
  'Interviewing', 
  'Offer',
  'Rejected',
  'On Hold'
];

export async function listJobApps() {
  const { data, error } = await supabase
    .from('job_applications')
    .select('*')
    .order('created_at', { ascending: false });
  
  if (error) throw error;
  return data;
}

export async function upsertJobApp(app) {
  const { data: userRes } = await supabase.auth.getUser();
  if (!userRes?.user) throw new Error('Not signed in');
  
  const payload = { 
    ...app, 
    user_id: userRes.user.id,
    updated_at: new Date().toISOString()
  };
  
  const { data, error } = await supabase
    .from('job_applications')
    .upsert(payload)
    .select()
    .single();
    
  if (error) throw error;
  return data;
}

export async function deleteJobApp(id) {
  const { error } = await supabase
    .from('job_applications')
    .delete()
    .eq('id', id);
    
  if (error) throw error;
}

export async function uploadResume(file, appId) {
  const { data: userRes } = await supabase.auth.getUser();
  if (!userRes?.user) throw new Error('Not signed in');
  
  const uid = userRes.user.id;
  const ext = file.name.split('.').pop()?.toLowerCase() || 'pdf';
  const path = `${uid}/${appId}/resume.${ext}`;

  // Upload (overwrites if exists)
  const { error: upErr } = await supabase.storage
    .from('applications')
    .upload(path, file, { 
      upsert: true, 
      contentType: file.type || 'application/octet-stream' 
    });
    
  if (upErr) throw upErr;

  // Save path on record
  const { data, error } = await supabase
    .from('job_applications')
    .update({ resume_path: path })
    .eq('id', appId)
    .select()
    .single();
    
  if (error) throw error;
  return data;
}

export async function getSignedResumeUrl(path, expiresSeconds = 60 * 60 * 24 * 7) {
  // 7 days by default
  const { data, error } = await supabase.storage
    .from('applications')
    .createSignedUrl(path, expiresSeconds);
    
  if (error) throw error;
  return data.signedUrl;
}

export async function deleteResume(appId) {
  const { data: userRes } = await supabase.auth.getUser();
  if (!userRes?.user) throw new Error('Not signed in');
  
  const uid = userRes.user.id;
  
  // Get the current resume path
  const { data: app, error: fetchError } = await supabase
    .from('job_applications')
    .select('resume_path')
    .eq('id', appId)
    .single();
    
  if (fetchError) throw fetchError;
  
  if (app.resume_path) {
    // Delete from storage
    const { error: deleteError } = await supabase.storage
      .from('applications')
      .remove([app.resume_path]);
      
    if (deleteError) throw deleteError;
    
    // Clear path from database
    const { error: updateError } = await supabase
      .from('job_applications')
      .update({ resume_path: null })
      .eq('id', appId);
      
    if (updateError) throw updateError;
  }
}




